/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxGetWorkspace } from "../../funcs/sandboxGetWorkspace.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetWorkspaceRequest$inboundSchema,
};

export const tool$sandboxGetWorkspace: ToolDefinition<typeof args> = {
  name: "sandbox-get-workspace",
  description: `Get Workspace Manifest

List files currently stored in the session workspace, including paths, sizes, and etags.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxGetWorkspace(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
